import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

export default function configureStore() {
    // Use a try-catch block to handle potential errors during store creation
    try {
        const composeEnhancers = 
            (typeof window !== 'undefined' && 
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || 
            compose;
            
        const store = createStore(
            rootReducer,
            composeEnhancers(applyMiddleware(thunk))
        );
        
        return store;
    } catch (error) {
        console.error('Error configuring Redux store:', error);
        // Return a minimal working store to prevent null errors
        return createStore(rootReducer, applyMiddleware(thunk));
    }
}